module.exports = __webpack_public_path__ + "img/SH2D_30006.eb63c514.png";